import { useAppDispatch } from 'store/hooks';
import channelSelectors from '../selectors';
import channelActions from '../actions';
import { useEffect } from 'react';

const useGetListLayouts = (isLazy = false) => {
  const dispatch = useAppDispatch();
  const data = channelSelectors.getListLayouts();

  const mutate = () => {
    dispatch(channelActions.getListLayouts.fetch());
  };

  useEffect(() => {
    if (isLazy) return;
    mutate();
  }, []);

  return [data, mutate] as const;
};

export default useGetListLayouts;
